module.exports = __webpack_public_path__ + "img/19.ed5432a7.png";